import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { fetchInterceptors } from "../../Api/fetchInterceptors";

const END_POINT = process.env.REACT_APP_END_POINT_USER_PROFILE;

export const fetchUserProfile = createAsyncThunk(
  "fetch/user/profile",
  async (_, thunkAPI) => {
    try {
      // const response = axiosInterceptors("/user/profile");
      const response = fetchInterceptors(END_POINT, "POST");
      return response;
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchUserProfileSlice = createSlice({
  name: "fetchUserProfile",
  initialState: {
    response: null,
    success: false,
    statusCode: null,
    error: null,
    loading: false,
  },
  reducers: {
    setDefaultProfileState: (state) => {
      state.response = null;
      state.success = false;
      state.statusCode = null;
      state.error = null;
      state.loading = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchUserProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.error = null;
          state.response = action.payload.data;
        } else {
          state.response = null;
          state.error = action.payload;
        }

        state.success = action.payload?.success;
        state.statusCode = action.payload?.code;
        state.success = action.payload?.success;
        state.loading = false;
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.error =
          "Refresh token has expired. Please log in again to obtain new tokens.";
        state.response = null;
        state.success = false;
        state.statusCode = 401;
        state.loading = false;
      });
  },
});

export const { setDefaultProfileState } = fetchUserProfileSlice.actions;

export default fetchUserProfileSlice.reducer;
